
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const getSafeLoginData = () => {
    const cookieData = Cookies.get('loginData');
    
    if (!cookieData) {
        return null;
    }
    
    try {
        return JSON.parse(cookieData);
    } catch (error) {
        console.error('Failed to parse loginData cookie:', error);
        console.error('Corrupted cookie value:', cookieData);
        Cookies.remove('loginData');
        
        return null;
    }
};

const getSafeToken = () => {
    const token = Cookies.get('token');
    if (token && typeof token === 'string' && token.length > 0) {
        return token;
    }
   if (token) {
        Cookies.remove('token');
    }
    
    return null;
};

const initialState = {
    loginData: getSafeLoginData(),  
    token: getSafeToken(),         
    isLoading: false,
    error: null
};

export const user_information = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLoginData(state, action) {
            state.loginData = action.payload.admin;
            state.token = action.payload.token;
           
            try {
                Cookies.set('loginData', JSON.stringify(action.payload.admin));
                Cookies.set('token', action.payload.token);
            } catch (error) {
                console.error('Failed to set cookies:', error);
                state.error = 'Failed to save login data';
            }
            
            console.log("action.payload : ", action.payload);
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },
        setError(state, action) {
            state.error = action.payload;
        },
        logout(state) {
            state.loginData = null;
            state.token = null;
            state.error = null;
            
            // ✅ Safe removal
            try {
                Cookies.remove('loginData');
                Cookies.remove('token');
            } catch (error) {
                console.error('Failed to remove cookies:', error);
            }
        }
    }
});

export const { setLoginData, setLoading, setError, logout } = user_information.actions;
export default user_information.reducer;